import React from "react";
import PropTypes from "prop-types";

import mutationFactory, {
  changeCardPhone as changeCardPhoneQ,
} from "model/gql/mutations";

const ChangeCardPhone = mutationFactory(changeCardPhoneQ);

function CardContactsChange(props) {
  const { cardId, phone, children } = props;
  return (
    <ChangeCardPhone cardId={cardId} phone={phone}>
      {({ mutate: changeCardContacts }) => children({ changeCardContacts })}
    </ChangeCardPhone>
  );
}

CardContactsChange.displayName = "CardContactsChange";

CardContactsChange.propTypes = {
  children: PropTypes.func.isRequired,
  cardId: PropTypes.string.isRequired,
  phone: PropTypes.string,
};

CardContactsChange.defaultProps = {};

export default CardContactsChange;



// WEBPACK FOOTER //
// ./src/data-containers/CardContactsChange/CardContactsChange.js